export const isValidImgUrl = (value: string) => {
  return value.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=\/]{2,256}\.(jpeg|jpg|gif|png)/g);
};

export const phoneNumberRegEx = /^\+[1-9]\d{1,14}$/i;

export const isValidPhoneNumber = (value: string) => {
  return (phoneNumberRegEx).test(value);
};

